import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

const WellnessPage: React.FC = () => {
  useEffect(() => {
    // Inject ConvertKit script for wellness page form
    const script = document.createElement('script');
    script.src = 'https://fullness-life.kit.com/e923a152bb/index.js';
    script.async = true;
    script.setAttribute('data-uid', 'e923a152bb');
    document.getElementById('ck_embed_form_wellness')?.appendChild(script);
    return () => {
      document.getElementById('ck_embed_form_wellness')?.removeChild(script);
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen" style={{ 
      fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
    }}>
      <Navbar />

      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes wireframeShift {
            0% {
              background-position: 0 0, 0 0, 0 0, 0 0;
            }
            100% {
              background-position: 12px 12px, 12px 12px, 8px 8px, -8px 8px;
            }
          }
          
          @keyframes pulseCorner {
            0%, 100% {
              opacity: 0.3;
              transform: scale(1);
            }
            50% {
              opacity: 0.8;
              transform: scale(1.1);
            }
          }
          
          @keyframes textGlow {
            0%, 100% {
              text-shadow: 
                0 0 2px #f5f5dc,
                0 0 4px rgba(245, 245, 220, 0.8),
                0 0 6px rgba(245, 245, 220, 0.6);
            }
            50% {
              text-shadow: 
                0 0 4px #f5f5dc,
                0 0 8px rgba(245, 245, 220, 0.9),
                0 0 12px rgba(245, 245, 220, 0.7);
            }
          }

          /* ConvertKit Form Styles */
          .ck-form * {
            box-sizing: border-box;
          }
          
          .ck-form {
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            max-width: 500px;
            margin: 0 auto;
          }
          
          .ck-form .ck-fields {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            margin-bottom: 20px;
          }
          
          .ck-form .ck-field {
            flex: 1;
            min-width: 200px;
          }
          
          .ck-form .ck-input {
            width: 100%;
            background: rgba(255, 255, 255, 0.95);
            font-size: 15px;
            padding: 12px 16px;
            border: 1px solid rgba(245, 245, 220, 0.3);
            border-radius: 4px;
            font-weight: 700;
            color: #000;
            transition: all 0.3s ease;
            font-family: inherit;
          }
          
          .ck-form .ck-input:focus {
            outline: none;
            border-color: #f5f5dc;
            box-shadow: 0 0 0 2px rgba(245, 245, 220, 0.2);
            background: #ffffff;
          }
          
          .ck-form .ck-input::placeholder {
            color: rgba(0, 0, 0, 0.6);
            opacity: 1;
          }
          
          .ck-form .ck-submit {
            background-color: #f5f5dc;
            color: #000;
            border: none;
            border-radius: 4px;
            font-weight: 600;
            font-size: 15px;
            padding: 12px 24px;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 100%;
            font-family: inherit;
            letter-spacing: 0.02em;
          }
          
          .ck-form .ck-submit:hover {
            background-color: #e6e6cd;
            transform: translateY(-2px);
            box-shadow: 0 4px 16px rgba(245, 245, 220, 0.3);
          }
          
          .ck-form .ck-powered-by {
            text-align: center;
            margin-top: 15px;
          }
          
          .ck-form .ck-powered-by a {
            color: rgba(245, 245, 220, 0.6);
            text-decoration: none;
            font-size: 12px;
            transition: color 0.3s ease;
          }
          
          .ck-form .ck-powered-by a:hover {
            color: rgba(245, 245, 220, 0.8);
          }

          @media (max-width: 640px) {
            .ck-form .ck-fields {
              flex-direction: column;
            }
            
            .ck-form .ck-field {
              min-width: auto;
            }
            section {
              padding: 2rem 0 !important;
            }
            .philosophy-section-inner {
              padding: 1.2rem !important;
              font-size: 1rem !important;
              word-break: break-word;
            }
            .philosophy-section-inner h3,
            .philosophy-section-inner p {
              font-size: 1rem !important;
            }
          }
        `
      }} />

      {/* Hero Section */}
      <section style={{ 
        minHeight: '80vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        textAlign: 'center', 
        background: '#1A252F',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Wireframe grid background */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          backgroundImage: `
            linear-gradient(rgba(245, 245, 220, 0.15) 0.5px, transparent 0.5px),
            linear-gradient(90deg, rgba(245, 245, 220, 0.15) 0.5px, transparent 0.5px),
            linear-gradient(45deg, rgba(245, 245, 220, 0.08) 0.5px, transparent 0.5px),
            linear-gradient(-45deg, rgba(245, 245, 220, 0.08) 0.5px, transparent 0.5px)
          `,
          backgroundSize: '12px 12px, 12px 12px, 8px 8px, 8px 8px',
          animation: 'wireframeShift 8s linear infinite',
          opacity: 0.6
        }}></div>
        
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto', 
          padding: '0 2rem',
          position: 'relative',
          zIndex: 2
        }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <h1 style={{ 
              fontSize: 'clamp(2.5rem, 6vw, 4rem)', 
              fontWeight: '500', 
              letterSpacing: '0.02em', 
              marginBottom: '1rem',
              lineHeight: '1.1',
              color: '#f5f5dc',
              textShadow: `
                0 0 1px #f5f5dc,
                0 0 3px rgba(245, 245, 220, 0.6),
                0 0 5px rgba(245, 245, 220, 0.4)
              `,
              position: 'relative',
              zIndex: 2,
              filter: 'drop-shadow(0 0 6px rgba(245, 245, 220, 0.2))'
            }}>
              Healthy Living is the Key to Success
            </h1>
            
            {/* Corner accent lines */}
            <div style={{
              position: 'absolute',
              top: '10%',
              left: '5%',
              width: '15px',
              height: '15px',
              border: '1px solid rgba(245, 245, 220, 0.4)',
              borderRight: 'none',
              borderBottom: 'none',
              animation: 'pulseCorner 3s ease-in-out infinite'
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '10%',
              right: '5%',
              width: '15px',
              height: '15px',
              border: '1px solid rgba(245, 245, 220, 0.4)',
              borderLeft: 'none',
              borderTop: 'none',
              animation: 'pulseCorner 3s ease-in-out infinite 1.5s'
            }}></div>
          </div>
          
          <p style={{ 
            fontSize: 'clamp(1.2rem, 3vw, 1.8rem)', 
            marginBottom: '2rem', 
            opacity: 0.9, 
            fontWeight: '300',
            color: 'rgba(245, 245, 220, 0.8)',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Optimize Your Body, Mind & Energy
          </p>
          <div style={{ fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto 3rem', opacity: 0.8, lineHeight: 1.7 }}>
            <p>Building wealth means nothing if you're too burnt out to enjoy it.</p>
            <p><strong>True success means having the energy to build, the clarity to think, and living in fullness.</strong></p>
          </div>
          <div style={{ 
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '4rem'
          }} id="ck_embed_form_wellness"></div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section style={{ padding: '6rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            The Performance Optimisation Method
          </h2>
          <div className="philosophy-section-inner" style={{ background: '#111', border: '1px solid #f5f5dc', padding: '3rem', margin: '2rem 0', textAlign: 'center', borderRadius: '8px' }}>
            <h3>Why Most Wellness Advice Fails Ambitious People</h3>
            <p style={{ fontSize: '1.2rem', margin: '2rem 0' }}>Generic wellness advice is built for average people living average lives. But you're not average.</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', margin: '3rem 0' }}>
              <div>
                <h4 style={{ color: '#FF6B6B', marginBottom: '1rem' }}>❌ Traditional Wellness</h4>
                <ul style={{ textAlign: 'left' }}>
                  <li>2-hour morning routines</li>
                  <li>Extreme diets that kill productivity</li>
                  <li>Meditation that puts you to sleep</li>
                  <li>Workouts that drain your energy</li>
                </ul>
              </div>
              <div>
                <h4 style={{ color: '#32CD32', marginBottom: '1rem' }}>✅ High-Performance Wellness</h4>
                <ul style={{ textAlign: 'left' }}>
                  <li>5-minute routines that compound</li>
                  <li>Sustainable nutrition for mental clarity</li>
                  <li>Active meditation that boosts focus</li>
                  <li>Strategic movement for more energy</li>
                </ul>
              </div>
            </div>

            <p style={{ fontSize: '1.1rem', fontWeight: 600, color: '#f5f5dc' }}>Your wellness should amplify your ambition, not compete with it.</p>
          </div>
        </div>
      </section>

      {/* The 4 Pillars */}
      <section style={{ padding: '6rem 0', background: '#0a0a0a', borderTop: '2px solid #f5f5dc' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            The 4 Pillars of Peak Performance
          </h2>
          <p style={{ textAlign: 'center', marginBottom: '3rem', fontSize: '1.2rem' }}>
            Optimized for entrepreneurs, creators, and those who want to live a full life
          </p>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
            gap: '2rem', 
            margin: '3rem 0' 
          }}>
            {[
              {
                icon: "⚡",
                title: "Energy Management",
                description: "Your energy is your most valuable currency. Learn to optimize sleep, nutrition, and recovery for sustained high performance without the crash.",
                items: ["Strategic caffeine timing", "Power nap protocols", "Energy-boosting meal timing", "Recovery optimization"]
              },
              {
                icon: "🧠",
                title: "Mental Clarity",
                description: "Clear thinking = better decisions = more money. Eliminate brain fog, enhance focus, and maintain peak cognitive performance under pressure.",
                items: ["Stress optimization techniques", "Decision fatigue elimination", "Focus enhancement protocols", "Mental resilience building"]
              },
              {
                icon: "💪",
                title: "Physical Optimization",
                description: "Your body is your vehicle for success. Maintain strength, mobility, and vitality without spending hours in the gym or following extreme diets.",
                items: ["15-minute daily movement", "Desk-based exercises", "Travel-friendly routines", "Injury prevention protocols"]
              },
              {
                icon: "⚖️",
                title: "Life Integration",
                description: "Sustainability beats intensity. Build habits that enhance your lifestyle rather than restrict it. Work with your schedule, not against it.",
                items: ["Habit stacking systems", "Travel wellness protocols", "Social situation navigation", "Long-term maintenance"]
              }
            ].map((pillar, index) => (
              <div key={index} style={{ 
                background: '#1a1a1a', 
                border: '1px solid #333', 
                padding: '2rem', 
                textAlign: 'center', 
                transition: 'all 0.3s ease',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <span style={{ fontSize: '3rem', marginBottom: '1rem', display: 'block' }}>{pillar.icon}</span>
                <h3 style={{ color: '#f5f5dc', fontSize: '1.5rem', marginBottom: '1rem' }}>{pillar.title}</h3>
                <p style={{ marginBottom: '1rem' }}>{pillar.description}</p>
                <ul style={{ textAlign: 'left', marginTop: '1rem' }}>
                  {pillar.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* My Routine Showcase
      <section style={{ padding: '6rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            My Daily Performance Routine
          </h2>
          <p style={{ textAlign: 'center', marginBottom: '3rem' }}>What actually keeps me sharp while building wealth in Abu Dhabi</p>
          
          <div style={{ background: '#111', padding: '3rem', borderRadius: '8px', margin: '2rem 0', border: '1px solid #f5f5dc' }}>
            <h3 style={{ textAlign: 'center', marginBottom: '2rem', color: '#f5f5dc' }}>5:30 AM - 10:00 PM: A Day of Optimized Performance</h3>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
              gap: '2rem', 
              margin: '2rem 0' 
            }}>
              {[
                { time: "5:30 AM - Energy Activation", description: "2-minute breathing exercise, hydration, natural light exposure. No phone for first 30 minutes." },
                { time: "6:00 AM - Movement", description: "15-minute bodyweight routine or walk. Movement before mental work = better cognitive performance all day." },
                { time: "6:30 AM - Peak Work", description: "Most important work when brain is fresh. Create content, strategic planning, complex problem solving." },
                { time: "12:00 PM - Strategic Break", description: "Protein-rich lunch, 10-minute walk, brief meditation. Reset for afternoon productivity." },
                { time: "6:00 PM - Transition", description: "End work, review day, plan tomorrow. Clear mental boundary between work and personal time." },
                { time: "9:30 PM - Recovery", description: "Blue light reduction, reading, gratitude practice. Prepare mind and body for restorative sleep." }
              ].map((step, index) => (
                <div key={index} style={{ 
                  background: '#1a1a1a', 
                  padding: '1.5rem', 
                  borderLeft: '3px solid #f5f5dc', 
                  borderRadius: '4px' 
                }}>
                  <h4 style={{ color: '#f5f5dc', marginBottom: '0.5rem' }}>{step.time}</h4>
                  <p>{step.description}</p>
                </div>
              ))}
            </div>
            
            <p style={{ textAlign: 'center', marginTop: '2rem', fontStyle: 'italic', color: '#f5f5dc' }}>
              "This isn't about perfection - it's about consistency. I follow this 80% of the time and feel amazing."
            </p>
          </div>
        </div>
      </section> */}

      {/* Offerings */}
      <section style={{ padding: '6rem 0' }} id="transform">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            Start Your Wellness Transformation
          </h2>
          
          <h3 style={{ textAlign: 'center', margin: '3rem 0 2rem', color: '#4CAF50' }}>FREE Resources (Start Here)</h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
            gap: '2rem', 
            margin: '3rem 0' 
          }}>
            {[
              {
                title: "5-Minute Peak Performance Routine",
                description: "The routine I use in good and bad moments",
                tag: "FREE",
                color: "#4CAF50"
              },
              {
                title: "Energy Management for an Evolving Landscape",
                description: "Thrive in an internally, rapidly changing world",
                tag: "FREE",
                color: "#4CAF50"
              },
              {
                title: "Creatine: Fuel Your Body and Brain",
                description: "The one supplement that enhances both muscle and mind",
                tag: "FREE",
                color: "#4CAF50"
              }
            ].map((item, index) => (
              <div key={index} style={{ 
                background: '#1a1a1a', 
                border: '1px solid #333', 
                padding: '2rem', 
                textAlign: 'center', 
                position: 'relative', 
                overflow: 'hidden',
                borderColor: item.color
              }}>
                <div style={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  background: item.color,
                  color: 'white',
                  padding: '0.5rem 1rem',
                  fontWeight: 600,
                  fontSize: '0.9rem'
                }}>
                  {item.tag}
                </div>
                <h3 style={{ fontSize: '1.4rem', marginBottom: '1rem', color: '#f5f5dc' }}>{item.title}</h3>
                <p style={{ marginBottom: '2rem', opacity: 0.8 }}>{item.description}</p>
                <a 
                  href="#ck_embed_form_wellness" 
                  onClick={e => {
                    e.preventDefault();
                    const form = document.getElementById('ck_embed_form_wellness');
                    let target: HTMLElement | null = form;
                    if (form) {
                      // Try to find the first input (first name field)
                      const input = form.querySelector('input[type="text"]');
                      if (input) target = input as HTMLElement;
                      if (target) {
                        const y = target.getBoundingClientRect().top + window.pageYOffset - 40; // 40px offset for nav
                        window.scrollTo({ top: y, behavior: 'smooth' });
                      }
                    }
                  }}
                  style={{
                    background: '#f5f5dc',
                    color: '#000',
                    border: 'none',
                    padding: '1.25rem 3rem',
                    fontSize: '1rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    letterSpacing: '0.02em',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 16px rgba(245, 245, 220, 0.2)',
                    textDecoration: 'none',
                    display: 'inline-block'
                  }}
                >
                  SIGN UP TO RECEIVE
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Performance Stats */}
      <section style={{ padding: '6rem 0', background: '#111' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            The Performance Advantage
          </h2>
          <p style={{ textAlign: 'center', marginBottom: '3rem' }}>What optimized wellness actually delivers</p>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '2rem', 
            margin: '3rem 0',
            textAlign: 'center'
          }}>
            {[
              { number: "4.5x", label: "Better Decision Making" },
              { number: "73%", label: "Increased Energy Levels" },
              { number: "2.3x", label: "Improved Focus Duration" },
              { number: "89%", label: "Reduced Stress Levels" }
            ].map((stat, index) => (
              <div key={index} style={{ 
                background: '#1a1a1a', 
                padding: '2rem', 
                borderRadius: '8px', 
                border: '1px solid #333' 
              }}>
                <span style={{ fontSize: '3rem', fontWeight: 700, color: '#f5f5dc', display: 'block' }}>
                  {stat.number}
                </span>
                <div style={{ opacity: 0.8, marginTop: '0.5rem' }}>{stat.label}</div>
              </div>
            ))}
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <h3 style={{ color: '#f5f5dc', marginBottom: '1rem' }}>The Bottom Line</h3>
            <p style={{ fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto' }}>
              Peak performance isn't about grinding harder - it's about optimizing smarter. 
              When your energy is high, your decisions are better. When your decisions are better, your results compound.
            </p>
          </div>
        </div>
      </section>

      {/* Social Proof */}
      {/* <section style={{ background: '#111', padding: '4rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            Real Results from High-Achievers
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginTop: '3rem' }}>
            {[
              {
                text: "Increased my productivity 3x while working fewer hours. The energy management protocols are game-changing.",
                author: "Alex Chen, Tech Entrepreneur"
              },
              {
                text: "Lost 15kg and gained mental clarity. Finally found sustainable wellness that fits my startup schedule.",
                author: "Sarah Williams, Founder"
              },
              {
                text: "Beat burnout without slowing down. These aren't just wellness tips - they're performance multipliers.",
                author: "James Rodriguez, Investment Banker"
              }
            ].map((testimonial, index) => (
              <div key={index} style={{ 
                background: '#1a1a1a', 
                border: '1px solid #333', 
                padding: '2rem', 
                textAlign: 'center', 
                borderRadius: '8px',
                position: 'relative'
              }}>
                <div style={{
                  content: '"',
                  fontSize: '4rem',
                  color: '#f5f5dc',
                  position: 'absolute',
                  top: '-1rem',
                  left: '1rem',
                  opacity: 0.3
                }}>"</div>
                <p style={{ fontStyle: 'italic', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  {testimonial.text}
                </p>
                <div style={{ fontWeight: 600, color: '#f5f5dc' }}>
                  - {testimonial.author}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Wellness Tools */}
      {/* <section style={{ background: '#0a0a0a', padding: '6rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            Free Performance Tools
          </h2>
          <p style={{ textAlign: 'center', marginBottom: '3rem' }}>Instant optimization for immediate results</p>
          
          {[
            {
              emoji: "⚡",
              title: "Energy Level Tracker",
              description: "Monitor your daily energy patterns to identify peak performance windows and energy drains.",
              type: "energy"
            },
            {
              emoji: "😴",
              title: "Sleep Optimization Calculator",
              description: "Input your schedule and get personalized sleep/wake times for optimal cognitive performance.",
              type: "sleep"
            },
            {
              emoji: "🎯",
              title: "Stress Response Assessment",
              description: "Identify your stress triggers and get personalized protocols for maintaining peak performance under pressure.",
              type: "stress"
            }
          ].map((tool, index) => (
            <div key={index} style={{ 
              background: '#1a1a1a', 
              border: '1px solid #333', 
              padding: '2rem', 
              margin: '1rem 0', 
              cursor: 'pointer', 
              transition: 'all 0.3s ease',
              borderRadius: '8px'
            }} onClick={() => openTool(tool.type)}>
              <h3>{tool.emoji} {tool.title}</h3>
              <p>{tool.description}</p>
              <div style={{ marginTop: '1rem', color: '#f5f5dc', fontWeight: 600 }}>Start Tracking →</div>
            </div>
          ))}
        </div>
      </section> */}

      {/* Free Performance Section */}
      {/* <section style={{ padding: '6rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            textAlign: 'center', 
            marginBottom: '3rem',
            color: '#f5f5dc',
            textShadow: '0 0 10px rgba(245, 245, 220, 0.2)'
          }}>
            Free Performance Assessment
          </h2>
          <p style={{ textAlign: 'center', marginBottom: '3rem' }}>Get instant insights into your current wellness state</p>
          
          {[
            {
              emoji: "💪",
              title: "Energy Level Assessment",
              description: "Calculate your current energy baseline and identify improvement areas.",
              type: "energy"
            },
            {
              emoji: "🧠",
              title: "Stress Resilience Calculator",
              description: "Measure your stress management capacity and get personalized recommendations.",
              type: "stress"
            },
            {
              emoji: "🌙",
              title: "Sleep Quality Analyzer",
              description: "Evaluate your sleep patterns and receive optimization strategies.",
              type: "sleep"
            }
          ].map((tool, index) => (
            <div key={index} style={{ 
              background: '#1a1a1a', 
              border: '1px solid #333', 
              padding: '2rem', 
              margin: '1rem 0', 
              cursor: 'pointer', 
              transition: 'all 0.3s ease' 
            }} onClick={() => openTool(tool.type)}>
              <h3>{tool.emoji} {tool.title}</h3>
              <p>{tool.description}</p>
              <a 
                href="#hero-form" 
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' });
                }}
                style={{
                  background: '#f5f5dc',
                  color: '#000',
                  border: 'none',
                  padding: '1.25rem 3rem',
                  fontSize: '1rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  letterSpacing: '0.02em',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 16px rgba(245, 245, 220, 0.2)',
                  textDecoration: 'none',
                  display: 'inline-block',
                  marginTop: '1rem'
                }}
              >
                SIGN UP TO RECEIVE
              </a>
            </div>
          ))}
        </div>
      </section> */}

      {/* Final CTA */}
      <section style={{ background: 'linear-gradient(135deg, #1a1a1a 0%, #000 100%)', padding: '6rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', textAlign: 'center' }}>
          <h2 style={{ 
            fontSize: 'clamp(2rem, 4vw, 3rem)', 
            fontWeight: 500, 
            marginBottom: '2rem',
            color: '#f5f5dc'
          }}>
            Ready to Master Your Wellness Edge?
          </h2>
          <p style={{ fontSize: '1.3rem', margin: '2rem auto', maxWidth: '600px' }}>
            Stop letting stress control your life. Start building the energy and vitality you deserve.
          </p>
          
          <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap', margin: '3rem 0' }}>
            <a 
              href="#ck_embed_form_wellness" 
              onClick={e => {
                e.preventDefault();
                const form = document.getElementById('ck_embed_form_wellness');
                let target: HTMLElement | null = form;
                if (form) {
                  // Try to find the first input (first name field)
                  const input = form.querySelector('input[type="text"]');
                  if (input) target = input as HTMLElement;
                  if (target) {
                    const y = target.getBoundingClientRect().top + window.pageYOffset - 40; // 40px offset for nav
                    window.scrollTo({ top: y, behavior: 'smooth' });
                  }
                }
              }}
              style={{
                background: '#f5f5dc',
                color: '#000',
                border: 'none',
                padding: '1.25rem 3rem',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                letterSpacing: '0.02em',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 16px rgba(245, 245, 220, 0.2)',
                textDecoration: 'none',
                display: 'inline-block'
              }}
            >
              SIGN UP TO RECEIVE
            </a>
            {/* <a 
              href="#hero-form" 
              onClick={(e) => {
                e.preventDefault();
                const form = document.getElementById('hero-form');
                const navHeight = 80; // Approximate height of nav bar
                const offset = 40; // Increased padding for better visibility
                if (form) {
                  const formPosition = form.getBoundingClientRect().top + window.pageYOffset;
                  window.scrollTo({
                    top: formPosition - navHeight - offset,
                    behavior: 'smooth'
                  });
                }
              }}
              style={{
                background: 'transparent',
                border: '2px solid #f5f5dc',
                color: '#f5f5dc',
                padding: '1.25rem 3rem',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                letterSpacing: '0.02em',
                transition: 'all 0.3s ease',
                textDecoration: 'none',
                display: 'inline-block'
              }}
            >
              SIGN UP TO RECEIVE
            </a> */}
          </div>
          
          {/* <p style={{ marginTop: '2rem', opacity: 0.8 }}>
            Join 15,000+ people building wellness with Fullness Life
          </p> */}
        </div>
      </section>
    </div>
  );
};

export default WellnessPage; 